export default __webpack_public_path__ + "static/media/logo.4b25ccf5.png";